<div *ngFor="let insurance of insurancesFormArray.controls; let i=index">
  <div class="row" [formGroup]="insurance">
    <div class="col-sm-5 offset-sm-1">
      <mat-form-field appearance="outline">
        <mat-label>Select an insurance</mat-label>
        <mat-select placeholder="Select an insurance" formControlName="insuranceId" (selectionChange)="processInsurances()">
          <mat-option *ngFor="let insurance of allInsurances" [value]="insurance.id" [hidden]="!insurance.ext.active">{{insurance.text}}</mat-option>
        </mat-select>
        <mat-error>
          This field is required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-sm-5">
      <mat-form-field appearance="outline">
        <mat-label>Insurance / Warranty amount (inc GST)</mat-label>
        <input matInput placeholder="Insurance / Warranty amount (inc GST)" type="number" formControlName="insuranceAmount" (change)="processInsurances()">
        <span matPrefix>$&nbsp;</span>
        <span matSuffix>.00</span>
        <mat-error>
          Must be greater than supplied value
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-sm-1">
      <button type="button" mat-icon-button (click)="removeInsurance(i)" color="warn"><mat-icon>remove_circle</mat-icon></button>
      <button type="button" mat-icon-button (click)="addInsurance(i)" color="primary" *ngIf="i === insurancesFormArray.controls.length - 1"><mat-icon>add_circle_outline</mat-icon></button>
    </div>
  </div>
</div>
